import {ReactNode, useState} from "react";
import {Button, Kbd, Modal, Text} from "@mantine/core";
import {useDisclosure} from "@mantine/hooks";
import {Trans, useTranslation} from "react-i18next";
import {DibJsonNode} from "../types";
import ArrowsMaximize from "../../../assets/arrows-maximize.svg?react";
import classes from "./TableLEGACY.module.css";

type Props = {
    node: DibJsonNode;
    children: ReactNode[];
};

export const TableLEGACY = ({node, children}: Props) => {
    const {t} = useTranslation();
    const kind = node.kind ?? "";
    const [opened, {open, close}] = useDisclosure(false);
    const [overflows, setOverflows] = useState(false);

    const wrapperRefCallback = (el: HTMLDivElement | null) => {
        if (el) setOverflows(el.scrollWidth > el.clientWidth);
    };

    const noBorder = kind.includes("tbNoBorder");
    const tableClassName = noBorder
        ? `${classes.table} ${classes.tableNoBorder}`
        : classes.table;

    return (
        <>
            {overflows && (
                <Button
                    variant="subtle"
                    size="compact-sm"
                    color="dark"
                    onClick={open}
                    className={classes.fullscreenButton}
                    leftSection={<ArrowsMaximize width={14} height={14} />}
                >
                    {t("table.openFullscreen", "Åpne tabell i fullskjerm")}
                </Button>
            )}
            <div className={classes.tableWrapper} ref={wrapperRefCallback}>
                <table className={tableClassName}>{children}</table>
            </div>
            <Modal
                fullScreen
                radius={0}
                opened={opened}
                onClose={close}
                title={
                    <Text>
                        <Trans
                            i18nKey="table.fullscreenTitle"
                            components={{span: <Kbd />}}
                        />
                    </Text>
                }
                centered
            >
                <table className={tableClassName}>{children}</table>
            </Modal>
        </>
    );
};
